module.exports = __webpack_public_path__ + "img/11s.bf72cfe3.png";